export const settingsInitial = Object.freeze({
  enabled: false,
  punchPhotoEnabled: false,
  userAmended: null,
  userAmendedName: null,
  dateAmended: null,
});

export default Object.freeze({
  data: settingsInitial,
  loading: false,
  saving: false,
  loaded: false,
});
